// Inside the thread runtime: publishes the thread's App build (live-build-model.ts) for its canvas (live-build.tsx).
import { useEffect, useMemo, type FC } from 'react';
import { useAuiState } from '@assistant-ui/react';
import { useNamespaceCopy } from '@/i18n/ns';
import buildWatchCopy from '@/i18n/ns/build-watch';
import { answerSeen, noteAnswerWorking, publishAppBuild } from './live-build';
import { appBuildState } from './live-build-model';

export const AppBuildObserver: FC<{ threadId: string }> = ({ threadId }) => {
  const copy = useNamespaceCopy(buildWatchCopy);
  const running = useAuiState((s) => s.thread.isRunning);
  const messages = useAuiState((s) => s.thread.messages) as unknown as Parameters<
    typeof appBuildState
  >[0];
  const state = useMemo(() => {
    // The answer working now is one this page saw: the builds it makes are newer than anything opened before it.
    const last = messages.at(-1) as { id?: string; role?: string } | undefined;
    if (running && last?.role === 'assistant' && last.id) noteAnswerWorking(last.id);
    return appBuildState(messages, threadId, running, copy, answerSeen);
  }, [messages, threadId, running, copy]);
  useEffect(() => publishAppBuild(threadId, state), [threadId, state]);
  return null;
};
